import { render, staticRenderFns } from "./WhatsAHa.vue?vue&type=template&id=2ff9cf16&scoped=true&"
import script from "./WhatsAHa.vue?vue&type=script&lang=js&"
export * from "./WhatsAHa.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAHa.vue?vue&type=style&index=0&id=2ff9cf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9cf16",
  null
  
)

export default component.exports